module.exports = fox._r("images/welcome-block-image.jpg", __webpack_public_path__ + "images/welcome-block-image.jpg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/welcome-block-image.jpg
// module id = 1030
// module chunks = 4